<template>
  <div class="content">
    <div class="header" v-for="(item,index) in info" :key="index">
      <h6>{{item.title}}</h6>
      <p v-for="(i,j) in item.content" :key="j">{{i}}</p>
    </div>
    <div class="footer">
      <span>广州渠道无忧网络技术服务有限公司</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      info: [
        {
          title: "",
          content: [
            '本直播主播入驻协议（以下称“本协议”）由您与广州渠道无忧网络技术服务有限公司（以下称“公司”或“本公司”）签订。为更好地向您提供服务，请您务必在使用本公司提供的直播服务前，认真阅读并充分理解本协议的全部内容，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、同意开通和使用特殊单项服务的条款、法律适用和争议解决条款等。其中，免除或者限制责任条款等重要内容将以加粗形式提示您注意，您应重点阅读。'
          ]
        },
        {
          title: "",
          content: [
            '若您使用本公司提供的直播及相关服务，则视为您已充分理解本协议并承诺作为本协议的一方当事人接受本协议的约束；在您阅读本协议的过程中，如您不同意本协议或其中任何条款的约定，您应立即停止使用本公司提供的直播及相关服务。'
          ]
        },
        {
          title: "",
          content: [
            '本公司不鼓励未成年人使用相关服务，若您是未成年人，请您在监护人的陪同及指导下认真阅读并充分理解本协议，并委托您的监护人或在监护人的明示同意下进行相关操作，否则不得使用公司提供的直播及相关服务。'
          ]
        },
        {
          title: "1. 总则",
          content: [
            '1.1 本协议所称"平台"是指公司及其关联公司拥有或实际运营的域名为"www.qudao51.com"的网站以及"探店吃喝玩乐"客户端，以下称为“平台”，基于业务开展需要及运营规划安排，公司可能适时更新前述网站及客户端（包括但不限于对前述网站、客户端进行增减或对其名称、域名进行变更），您知悉并同意，前述网站及客户端在更新后同样适用本协议项下的约定，公司无需另行单独通知您或事先征得您同意。',
            '您根据公司注册要求及规则入驻平台成为直播主播，方可使用平台提供的相关服务开展包括但不限于在线游戏解说、游戏技巧展示、唱歌跳舞或其他才艺展示等视频内容的直播活动（以下简称"网络直播活动"）。',
            '1.3 您应充分了解平台之各项规则及要求（包括平台已发布及可能未来不时发布的对用户的各项管理规则及要求等，包括但不限于本协议以及用户服务协议、隐私政策、自律公约、直播行为规范、费用结算协议等，以下合称“平台规则”）。同时，您保证您不是互联网信息办公室、文化和旅游部及各级文化市场综合执法机构、全国"扫黄打非"办公室等相关主管部门公布的警示名单或黑名单中的人员，且有条件、有能力、有资格履行本协议约定的主播职责及义务，同时该等职责及义务的履行不会导致您违反任何对您有约束力的判决、裁决、合同、协议或其他文件。本协议对您构成有效的、具有约束力的、可强制执行的法定义务，您对本协议下所有条款及定义等内容均已明确知悉，并无疑义。若您不具备前述条件，请您立即停止使用本公司提供的直播及相关服务。',
            '1.4 您承诺并声明，您在平台开展的网络直播活动均符合相关法律规定，且不得以履行本协议为名义，从事违反中华人民共和国及您所在地的相关法律规定的行为。',
            '1.5 您认可，您与公司之间属平等的商事合作关系，不构成任何法律层面的雇佣、劳动、劳务关系，您无须遵守公司的劳动规章制度，公司亦无需为您缴纳任何社会保险和提供任何员工福利。',
            '1.6 如您的帐号使用了探店吃喝玩乐的帐号升级服务（以下称“探店吃喝玩乐升级帐号”）、可同时在探店吃喝玩乐开直播的，则您应同时遵守探店吃喝玩乐平台的各项协议和相关规则，包括但不限于《探店吃喝玩乐用户服务协议》、《探店吃喝玩乐隐私政策》等。您在平台发生任何行为导致该平台对您的帐号采取了任何措施的，该措施将同时在各平台对您生效。'
          ]
        },
        {
          title: "2. 权利和义务",
          content: [
            "2.1 您应按照平台要求完成实名认证，且提供的注册信息应当完整、真实、合法、有效。",
            "2.2 平台有权基于您网络直播活动开展的具体情况（包括但不限于内容质量、互动传播效果、直播活跃度、直播时长、内容稀缺性等）独立对您进行考察、评审，以酌情决定是否给予您一定的奖励或处罚。如公司希望与您就网络直播活动等事项进行深入合作，可由双方进行友好协商并另行签订合作协议。 ",
            "2.3 您的行为（包括但不限于艺术行为、表演行为及各种其他行为，以下并称“行为”）应符合法律法规、行业自律公约、平台规则及本协议之规定，公司有权依据前述规定对您的行为进行管理，包括但不限于：",
            "法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的内容；",
            "反对宪法所确定的基本原则，或危害国家统一、主权和领土完整的言论；",
            "歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或其他方式侵害英雄烈士姓名、肖像、名誉、荣誉的内容；",
            "表演方式恐怖、残忍、暴力血腥、低俗，危害表演者自身或他人身心健康的内容；",
            "任何暴力和/或自残的内容；",
            "任何危害或可能危害自身或他人生命健康、财产安全的内容，包括但不限于利用刀具等危险器械表演、高空攀岩等；",
            "怂恿、诱导他人参与可能会造成人身伤亡或财产损失的危险或违法活动的内容；",
            "利用人体缺陷或以展示人体变异等方式招徕用户的；",
            "以偷拍偷录等方式，侵害他人合法权益的；",
            "以虐待动物等方式进行表演的；",
            "使用未取得网络游戏出版物号的网络游戏产品进行网络游戏技法展示或解说，或对该等网络游戏产品进行宣传推广的；",
            "侵害未成年人合法权益、损害未成年人身心健康，或可能引发未成年人模仿不安全行为及违反社会公德行为、诱导未成年人不良嗜好的；",
            "侮辱、诽谤他人，或在直播间肆意喧哗、辱骂观众或其他用户、挑起用户间矛盾等；",
            "不当仪容仪态和行为方式的内容；",
            "不当评述自然灾害、疫情、重大事故等灾难等内容。",
            "2.3.2 未经公司事先书面同意，您不得在直播中植入任何广告或具有推广性质的内容。",
            "2.3.3 您有责任积极维护自身形象，营造良好的互动环境，在平台内外均不得作出有损自身、公司及/或平台的品牌、形象、声誉的行为。",
            "2.3.4 您不得利用平台提供的直播及相关服务，在平台内、外进行任何违法违规或不当行为（包括但限于诈骗、赌博、非法转移财产、传播虚假信息等），如您发生上述行为或平台有理由相信您发生了上述行为（如平台收到相关投诉等），平台有权根据实际情况对您采取包括但不限于暂停支付收益、冻结或封禁帐号的措施，同时还有权保存您的相关信息并向相关执法、司法机构提供以依法追究您的法律责任。如因此给平台造成了任何损失的，平台有权向您全额追偿。",
            "2.3.5 您承诺您不会冒用公司及/或平台之名义对外发布任何信息，包括但不限于假借公司及/或平台之名义，或者谎称自己是公司及/或平台工作人员进行商业合作、开展培训等，亦不会夸大性或虚假性地宣传您与公司及/或平台之间的关系，包括但不限于宣称您与公司及/或平台存在战略合作关系、联盟关系、投资关系或其他关联关系，号称自己是平台的头部主播、重金培养打造的主播等等。",
            "2.4 针对您个人的人身形象（包括但不限于艺术形象、表演形象、广告形象、平面形象，以下合称“人身形象”）及身份标识（包括但不限于姓名、昵称、艺名、肖像、签名、声音、符号、动画图标等，以下合称“身份标识”）以及通过平台发布的内容、开展网络直播活动所形成的内容（包括但不限于文字、图片、图像、音频、视频和/或音频中的音乐、声音、对话等），您同意授予公司及其关联方、控制公司、继承公司一项全球范围内、免费、非独家、可再许可（通过多层次）的权利（包括但不限于复制权、翻译权、汇编权、信息网络传播权、改编权、制作衍生品、表演和展示等权利），使用范围包括但不限于在当前或其他网站、应用程序、产品或终端设备等，以下将您授权的上述内容合称为“授权内容”。您在此确认并同意，您授予的上述权利包括在与授权内容、平台相关服务、公司和/或公司品牌有关的任何广告、营销、宣传推广和/或研究中使用和以其他方式开发内容（全部或部分）的权利和许可，为避免疑义，公司有权使用、复制和展示您的人身形象及/或身份标识，以及对授权内容添加商业标识、利用其进行其他开发或将其植入其他内容。同时，您确认授权公司有权以公司自身名义或委托专业第三方对侵犯上述授权内容进行代维权，维权形式包括但不限于：监测侵权行为、发送维权函、提起诉讼或仲裁、调解、和解等，公司有权对维权事宜做出决策并独立实施。",
            "2.5 您应为自身树立积极、正面、阳光的公众形象（包括但不仅限于妆容、服饰与言行等），不得出现吸毒、盗窃、嫖娼、出轨、赌博、诈骗等违反法律法规、公共秩序以及其他影响您公众形象的言论、行为或事由，不得从事任何损害公司及其关联公司及平台产品和品牌形象的行为。",
            "2.6 若您通过平台依约开展网络直播活动，则您有权根据平台届时有效的费用结算政策和规则、基于其他用户向您赠送的虚拟礼物等情形获得直播相关的分成收益，并依据平台提供的提现方式和提现规则自行通过平台进行操作以提取上述分成收益。探店吃喝玩乐升级帐号内，您在探店吃喝玩乐内产生的直播服务成果及/或分成收益将合并计算、汇总展示，您可在探店吃喝玩乐平台申请提现，当您在平台申请提现后，各平台的可提现金额均会相应减少，具体可提现金额和已提现金额以相关产品页面为准。为避免疑义，您理解并同意，您开展网络直播活动相关的数据及应获得收益的具体金额以平台系统所统计的结果为准。特别地，您同意，若您接受了公会的入会邀请并成为该公会旗下主播，则公司将基于该公会设定或其提供的分成比例计算您的分成收益，若您不认可所获收益的分成比例、具体金额，或认为与您和公会两方之间的约定存在冲突，从而产生异议、争议、纠纷的，应由您与该公会自行处理、解决，与公司及平台无涉。",
            "2.7 您同意，公司或公司指定的第三方有权根据国家相关法律法规就您在本协议下所获得的分成收益代扣代缴个人所得税、手续费等相关的税费及成本。",
            "2.8 如经公司内部评估，公司做出对特定用户在平台的消费金额予以退还之决策的（包括但不限于未成年人、无民事行为能力人、限制民事行为能力人消费而应退款，用户使用违法收入消费的情形等），您应当无条件就您已获得的与特定用户消费金额相对应的分成收益进行退款，且您授权公司有权在您于平台待收取的分成收益中直接扣除，如您的当期分成收益金额不足需退款金额的，您应在公司发生通知后5个工作日内按照公司告知的方式支付，如您未按时支付的，则公司有权在您后续产生的分成收益中予以扣除。",
            "2.9 如经公司核查，认定您在平台待收取的分成收益或您已获支付的分成收益中含有无效收益（包括但不限于您因违法违规直播所产生的收益，您因您自己或其他用户的作弊行为而获取的收益，应司法、行政机关要求您应退款的收益等）的，您授权公司有权在您于平台待收取的分成收益中直接扣除该等无效收益，如您的当期分成收益金额少于无效收益金额的，您应在公司发生通知后5个工作日内按照公司告知的方式补足，如您未按时补足的，则公司有权在您后续产生的分成收益中予以扣除。"
          ]
        },
        {
          title:"3. 保密条款",
          content: [
            "3.1 您应严格遵守公司的保密制度，承诺无限期保守公司和平台的商业秘密。商业秘密是指由公司提供的、或者您在双方合作期间了解到的、或者公司对其他方承担保密义务的，与公司业务有关的，能为公司带来经济利益，具有实用性的、非公知的所有信息，包括但不限于：技术信息、经营信息、公司相关活动信息、收益信息、工作人员信息、通讯信息以及与公司运营或管理有关的信息和文件（含本协议及相关协议内容）。",
            "3.2 您应严格遵守本协议，未经公司书面授权或同意，对公司的商业秘密不得：",
            "以任何方式向第三方进行传播、泄露（包括暗示）；",
            "为非本协议的目的而使用。",
            "3.3 因您违反约定使用或披露公司商业秘密使公司遭受任何名誉、声誉或经济上的直接或间接的损失，您应赔偿公司全部损失。",
            "3.4 以上保密条款并不因本协议的解除和终止而失效。"
          ]
        },
        {
          title: "4. 协议的解除、终止",
          content: [
            "4.1 您理解并同意，公司在本协议项下提供的直播及相关服务是按照现有技术和条件所能达到的现状提供的，公司会尽最大努力向您提供服务，以确保服务的连贯性和安全性。但您亦知悉并认可，公司不能随时或始终预见和防范技术及其他风险，包括但不限于因不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用服务以及其他的损失和风险；此外，除前述情况外，公司有权视法律法规、规章政策、交易安全、运营规划等具体情况随时单方中断、中止或终止本协议项下部分或全部服务，并将以平台页面公告或其他适当方式向用户发出通知（而不再另行单独通知您）。",
            "4.2 本协议期限届满或双方就解除本协议协商一致的，可终止本协议。",
            "4.3 若您出现下列任何情形之一，公司可以不经事先通知而随时解除本协议：",
            "您违反平台规则及/或本协议之约定的；",
            "您存在吸毒、盗窃、嫖娼、出轨、赌博、诈骗等违反法律法规、公共秩序以及其他影响您公众形象的言论、行为，或经公司独立判断认为您存在或涉嫌存在上述行为；",
            "因您原因直接或间接给公司利益及/或平台形象、声誉造成损害的；",
            "您以消极、不作为等不符合平台要求的方式履行本协议的（即使未构成违约），经公司通知后合理期限内仍未改正的；",
            "因异常情形的出现，公司认为您不适合进行本协议下服务事项，经公司通知后合理期限内异常情形仍未消除的；",
            "因平台业务调整，公司不再提供直播及相关服务的。",
            "4.4 无论本协议因为任何原因终止的，对于您在公司平台帐号中的全部数据或您因使用公司平台而存储在公司服务器中的数据等任何信息，公司可将该等信息保留或删除。",
            "4.5 如本协议因为任何原因终止的，您应自行处理好关于数据等信息的备份等事项，由此造成公司损失的，您应负责赔偿。"
          ]
        },
        {
          title: "5. 违约责任",
          content: [
            "5.1 若您存在违约行为的，公司有权独立判断并视您违约情节的严重程度采取下列某一项或者某几项管措施追究您的违约责任：",
            "预先警示；",
            "断开直播、拒绝您通过平台发布内容；",
            "限制您帐号的部分或全部功能；",
            "暂时冻结或者永久性地封停/冻结您的平台帐号；",
            "将您的平台帐号永久性地删除；",
            "拒绝您再次注册平台帐号；",
            "暂时中止您收益的结算和支付；",
            "扣除或清空您帐号内的全部或部分虚拟权益及收益金额作为您违约而应支付给公司的违约金，如该等违约金不足弥补公司损失（包括但不限于公司向第三方支付的赔偿款、行政罚款、公证费、鉴定费、差旅费、律师费、诉讼费等合理费用）的，您还应继续赔偿；",
            "预先警示；",
            "单方面解除本协议，终止双方基于本协议的所有合作事宜，不再支付尚未支付的收益费用，同时您应向公司退回所有已支付的款项。",
            "5.2 如因您的任何不实陈述或保证，或因您违反本协议项下的义务，或因您对第三方的侵权行为或违约行为，导致公司面临任何索赔、承担任何责任（如行政处罚等）或遭受任何损失，您应当采取适当的措施（包括但不限于与该第三方协调解决纠纷、采取公开声明消除影响等），保证公司免受上述事由的影响。在该等情形下，公司就其因此所受损失保留向您索赔的权利，如您的违约行为遭到媒体曝光，导致公司遭受不利影响及/或公关危机的，您应积极配合公司发表书面声明，澄清事实并向用户和/或公司道歉。"
          ]
        },
        {
          title: "6. 关于通知",
          content: [
            "6.1 公司可能会以网页公告、网页/弹窗提示、电子邮件、手机短信、常规信件传送、向您注册的平台账户的管理系统内发送站内信等方式中的一种或多种，向您送达关于本协议相关的各种通知、提示等信息，该等信息一经公司采取前述任何一种方式公布或发送，即视为送达并对您产生约束力，请您务必及时关注。",
            "6.2 若由于您提供的电子邮箱、手机号码、通讯地址等信息错误，导致您未收到相关通知、提示等信息的，您同意仍然视为您已经收到相关信息并受其约束，一切后果及责任由您自行承担。",
            "6.3 若您有事项需要通知公司的，应当按照公司对外正式公布的联系方式书面通知公司。"
          ]
        },
        {
          title: "7. 争议处理",
          content: [
            "7.1 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。",
            "7.2 本协议签订地为中华人民共和国北京市海淀区。若您和公司之间发生任何纠纷或争议，首先应友好协商解决；协商不成功的，双方均同意将纠纷或争议提交本协议签订地有管辖权的人民法院解决。"
          ]
        },
        {
          title: "8. 其他",
          content: [
            "8.1 为了向您提供更好的服务，或者基于法律法规规定、主管部门要求、业务开展情况等因素的更新与变化，公司有权在必要时修订本协议及/或平台规则的内容，修订后公司会通过平台发出修订后的版本，并将修订后的版本进行公示或者通过网页公告、站内信或其他适当的方式通知您修订的内容，以便您及时了解本协议的最新版本。如您于该等修订内容生效之后仍继续使用公司提供的直播服务，即视为您已同意接受该等修订内容；如您不接受修订后的相关内容，请您立即停止使用相关服务。",
            "8.2 平台规则的其他约定与本协议存在冲突的，以本协议为准。",
            "8.3 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。",
            "8.4 本协议项下公司、平台或相关产品、功能名称、协议名称变更的，不影响本协议的履行，以实际变更后的为准。",
            "8.5 若本协议之任何规定因与中华人民共和国法律抵触或被有管辖权的人民法院认定而无效或不可执行，则在不违反法律的前提下，这些条款将按照尽可能接近本协议原条文意旨的原则重新解析，且本协议其它规定仍应具有完整的效力及效果。"
          ]
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.content {
  .header {
    padding: 0px 29px;
    &:nth-child(1){
      color:#f00;
      p {
        text-indent: 2em;
      }
    }
    h6 {
      font-size: 30px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      margin: 35px 0 10px 0;
    }
    p {
      font-size: 26px;
      font-weight: 400;
      color: rgba(85, 85, 85, 1);
      line-height:40px;
    }
  }
  .footer {
    margin: 147px 0 27px;
    font-size: 26px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    text-align: center;
  }
}
</style>